import { Card } from "antd";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { NegotiationSimulationPanel } from "./NegotiationSimulationPanel";
import { NegotiationDetailInsights } from "./NegotiationDetailInsights";

export const NegotiationDetailsView: React.FC = () => {
    const params = useParams();
    const [negotiationId] = useState(Number(params.negotiationId));

    const panel = (
        <div>
            <Card bordered={false}>
                <NegotiationDetailInsights negotiationId={negotiationId} />
                <NegotiationSimulationPanel negotiationId={negotiationId} />
            </Card>
        </div>
    );

    return panel;
};
